export default __webpack_public_path__ + "static/media/gallery_05.2a49977f.jpg";